const apiUrl = '/api'

export default apiUrl